import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, OverlayLoader, BgLoader, UiButton } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";
import { Dropdown, Popconfirm, Menu } from 'antd';
import { MdOutlineClose } from "react-icons/md";
import { FiRefreshCcw } from "react-icons/fi";

const Fy = NiceModal.create(
  ({ id, subtitle, action, bgColor, note = "", data }) => {
    const [input, setInput] = useState(note);
    const [state, setState] = useState({ count: 0 });
    const [entry, setEntry] = useState([]);
    const modal = useModal();
    const [loader, showLoader] = useState(false);
    const schema = yup.object().shape({
      fy: yup.string().nullable().required('Select year'),

    }, []);
    const {
      register,
      handleSubmit,
      control,
      unregister,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      changeFy(data);
      //reset();
    };
    var changeFy = (e) => {
      showLoader(true)
      var form = document.querySelector("#fyform");
      var data = new FormData(form);

      instance({
        method: "post",
        url: "/fy_select",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          showLoader(false)
          if (response.data.status == 'success') {
            modal.resolve({ resolved: true, fy: response.data.fy });
            modal.hide();
          }
          if (response.data.status == 'error') {
            toast(response.data.msg, { type: "error" });
          }

        })
        .catch(function (response) { });
    };


    const fetchData = () => {
      instance
        .get("/get_fy")
        .then(function (response) {
          setState(response.data)

        })
        .catch(function (error) { })
        .then(function () { });
    }
    const handleDelete = (id) => {
      var tid = id;

      showLoader(true)
      instance
        .get("/delete_fy?id=" + tid)
        .then(function (response) {
          showLoader(false)
          if (response.data.status == 'success') {
            fetchData();
            toast(response.data.msg, { type: "success" });
          } else {
            toast(response.data.msg, { type: "error" });
          }
        })
    }

    const handleRefresh = (id) => {
      var tid = id;

      showLoader(true)
      instance
        .get("/regen_balance?fy=" + tid)
        .then(function (response) {
          showLoader(false)
          if (response.data.status == 'success') {
            fetchData();
            toast(response.data.msg, { type: "success" });
          } else {
            toast(response.data.msg, { type: "error" });
          }
        })
    }

    const genFy = () => {
      instance
        .get("/gen_fy")
        .then(function (response) {
          fetchData()

        })
        .catch(function (error) { })
        .then(function () { });
    }



    useEffect(() => {
      fetchData()



    }, []);



    const handleHide = () => {
      modal.hide();
    }



    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>FY</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={loader} />
        <BootstrapModal.Body>
          {state.status ?
            <form id="fyform" onSubmit={handleSubmit(onSubmitHandler)}>

              {state.fys.map((val, i) => (
                <div className="border p-2 mb-3 rounded d-flex align-items-center justify-content-between" key={i}>
                  <div className="form-check" >
                    <input className="form-check-input" type="radio" name="fy" id={`fy${i}`} defaultChecked={val.selected == 1 ? true : false} value={val.fy} {...register("fy")} />
                    <label className="form-check-label" htmlFor={`fy${i}`}>
                      {val.fy}
                    </label>
                  </div>
                  {state.master == 1 &&
                    <div>
                      {val.is_init == 0 &&
                        <Popconfirm
                          title="Opening Balance Recalculate?"
                          description="Are you sure to refresh opening balance?"
                          onConfirm={() => handleRefresh(val.fy)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <button className='btn btn-light btn-sm me-2' type="button"><FiRefreshCcw /></button>
                        </Popconfirm>
                      }
                      <Popconfirm
                        title="Delete?"
                        description="Are you sure to delete this?"
                        onConfirm={() => handleDelete(val.fy)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <button className='btn btn-light btn-sm' type="button"><MdOutlineClose /></button>
                      </Popconfirm>
                    </div>

                  }
                </div>
              ))}
              <div className="mt-1">
                <UiButton className="btn btn-light border btn-sm" onClick={() => genFy()} title={`Create FY ${state.next_fy}`}></UiButton>
              </div>
              {errors.fy && <small className="text-danger">{errors.fy.message}</small>}




              <input type="hidden" value={id} name="id" {...register("id")} />
              <div className="mt-4">
                <button className="w-100 btn btn-lg btn-primary" >Select</button>

              </div>
            </form>
            : <BgLoader />}
        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default Fy;
